export const SETTOKEN = 'SETTOKEN';
export const SETERROR = 'SETERROR';
export const LOADING = 'LOADING';

export const VERIFY_SCREEN = 'VERIFY_SCREEN';